export const COMPETITIONS = [
  { id: "quran", label: "تلاوة القرآن الكريم", icon: "BookOpenText" },
  { id: "swimming", label: "السباحة", icon: "Waves" },
  { id: "football", label: "كرة القدم", icon: "CircleDot" },
  { id: "gymnastics", label: "البتيناج", icon: "Dumbbell" },
  { id: "self_defense", label: "الدفاع عن النفس", icon: "Shield" },
  { id: "cooking", label: "الطبخ", icon: "ChefHat" },
];

export const WORKSHOPS = [
  { id: "drawing", label: "الرسم", icon: "Palette" },
  { id: "coloring", label: "التلوين", icon: "Brush" },
  { id: "handicrafts", label: "صناعات يدوية", icon: "Scissors" },
  { id: "clay", label: "الطين والصلصال", icon: "Sparkles" },
  { id: "photography", label: "التصوير", icon: "Camera" },
];

export const FESTIVAL_DATES = ["17", "18", "19"];
export const FESTIVAL_MONTH = "سبتمبر";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
